import { Pipe, PipeTransform } from '@angular/core'
import { Content } from './../../shared'

@Pipe({ name: 'contentFilter' })
export class ContentFilterPipe implements PipeTransform {
  public transform (contents: Content[], searchText: string): any[] {
    if (!contents) return []
    if (!searchText) return contents
    searchText = searchText.toLowerCase()
    return contents.filter((it) => {
      return it.name.toLowerCase().includes(searchText)
    })
  }
}
